import axios from 'axios';
import authHeader from '/src/services/auth-header';
const API_URL_V310 = process.env.VUE_APP_BASE_URL_API + '/voucher310/';

class Voucher310Service {

   getVoucherPdf( id ) {
      return axios.get(API_URL_V310 + 'get_voucher_pdf',
         { 
            params: { id: id },
            headers: authHeader() 
         }
      );
   }

   getVoucherRestData( id ) {
      return axios.get(API_URL_V310 + 'get_voucher_rest_data',
         { 
            params: { id: id },
            headers: authHeader() 
         }
      );
   }

   findChronicDisease() {
      return axios.get(API_URL_V310 + 'find_chronic_disease',
         { headers: authHeader() }
      );
   }

   findDrugCode310( code, cuil ) {
      return axios.get(API_URL_V310 + 'find_drug_code310',
         { 
            params: {
               code: code,
               cuil: cuil
            },
            headers: authHeader() 
         }
      );
   }

   findMedicalSpecialties() {
      return axios.get(API_URL_V310 + 'find_medical_specialties',
         { headers: authHeader() }
      );
   }
   /*
   findVouchers( findData ) {
      return axios.get(API_URL_V310 + 'find_vouchers',
         {  params: findData,
            headers: authHeader()
         }
      );
   }
   */
   findVouchers( findData ) {
      return axios.post(API_URL_V310 + 'find_vouchers', findData,
         {  headers: authHeader() }
      );
   }

   updateVoucher( upVoucher ) {
      return axios.post(API_URL_V310 + 'update_voucher', upVoucher,
         { headers: authHeader() }
      );
   }

   updateMonodrug( code ) {
      return axios.get(API_URL_V310 + 'update_monodrug',
         { 
            params: {
               code: code
            },
            headers: authHeader() 
         }
      );
   }

}

export default new Voucher310Service();